module.exports = __webpack_public_path__ + "static/media/DBHeaventNow-Italic.bc602591.ttf";